export enum FunctionOfTheLegalRepresentativeEnumFR {
	PRESIDENT_DIRECTEUR_GENERAL = 'Président directeur général',
	PRESIDENT = 'Président',
	DIRECTEUR_GENERAL = 'Directeur général',
	DIRECTEUR_GENERAL_DELEGUE = 'Directeur général délégué',
	GERANT = 'Gérant',
	AUTRE = 'Autre'
}
